/** "1:04.3" for a running clock. Always the same width, so it never jitters. */
export function formatClock(ms: number): string {
  const clamped = Math.max(0, ms)
  const totalSeconds = Math.floor(clamped / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const tenths = Math.floor((clamped % 1000) / 100)
  if (minutes > 0) {
    return `${minutes}:${String(seconds).padStart(2, '0')}.${tenths}`
  }
  return `${String(seconds).padStart(2, '0')}.${tenths}`
}

/** Whole seconds, for the pre-round countdown. */
export function formatSeconds(ms: number): string {
  return String(Math.max(0, Math.ceil(ms / 1000)))
}

export function formatDuration(seconds: number): string {
  if (seconds >= 60) {
    const minutes = seconds / 60
    return Number.isInteger(minutes) ? `${minutes}m` : `${seconds}s`
  }
  return `${seconds}s`
}

export function formatAnswerMs(ms: number | null): string {
  if (ms === null) return 'no answer'
  return `${(ms / 1000).toFixed(2)}s`
}

export function formatRelative(iso: string | Date | null): string {
  if (!iso) return ''
  const date = typeof iso === 'string' ? new Date(iso) : iso
  const diff = Date.now() - date.getTime()
  const minutes = Math.round(diff / 60_000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  return days === 1 ? 'yesterday' : `${days}d ago`
}
